/* eslint-disable prettier/prettier */
import moment from 'moment'

export function DateTimeFormat(date) {
    if (date) {
        return moment(date).format('MM/DD/YYYY HH:mm')
    }
}

export function DateTimeFormatWithSecond(date) {
    if (date) {
        return moment(date).format('MM/DD/YYYY hh:mm A')
    }
}

export function DateFormat(date) {
    if (date) {
        return moment(date).format('MM/DD/YYYY HH:mm')
    }
}

export function DayMonthYearFormatOnly(date) {
    if (date) {
        return moment(date).format('MM/DD/YYYY')
    }
}

export function DateTimeFormatForInput(date) {
    if (date) {
        return moment(date).format('YYYY-MM-DD')
    }
}